// Header search: suggestion chips while the field is empty, live results while typing, a dimmed page behind the open panel.
(() => {
  const form = document.getElementById('header-search');
  const panel = form?.querySelector('[data-search-panel]');
  if (!panel) return;
  const input = form.querySelector('input[name="q"]');
  const results = panel.querySelector('[data-search-results]');
  const toggle = document.getElementById('search-toggle');
  // The header has a backdrop-filter, so a fixed scrim inside it would be clipped to the header: it lives on <body>, just under the sticky header.
  const scrim = document.createElement('div');
  scrim.className = 'nl-search-scrim';
  document.body.append(scrim);
  const isOpen = () => form.classList.contains('open');
  const close = () => form.classList.remove('open');
  new MutationObserver(() => {
    document.documentElement.classList.toggle('nl-search-open', isOpen());
    toggle?.setAttribute('aria-expanded', isOpen());
  }).observe(form, { attributes: true, attributeFilter: ['class'] });
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && isOpen()) { close(); toggle?.focus(); }
  });
  let timer, request;
  input.addEventListener('input', () => {
    clearTimeout(timer);
    const terms = input.value.trim();
    if (!terms) { request?.abort(); panel.classList.remove('has-results'); results.replaceChildren(); return; }
    timer = setTimeout(async () => {
      request?.abort();
      request = new AbortController();
      const params = new URLSearchParams({ q: terms, 'resources[type]': 'product,collection', 'resources[limit]': '6', section_id: 'nl-predictive-search' });
      try {
        const response = await fetch(`${panel.dataset.url}?${params}`, { signal: request.signal });
        const html = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-predictive]');
        if (!html || input.value.trim() !== terms) return;
        results.replaceChildren(...html.childNodes);
        document.dispatchEvent(new Event('nl:money'));
        panel.classList.add('has-results');
      } catch (error) {
        // An aborted request was superseded by newer typing; any other failure leaves the chips in place.
      }
    }, 180);
  });
})();
